<template>
    <LayoutSub className="business_unit">
        <SubSection classList="pb-0">
            <h1>
                <strong class="c-red">기술연구소</strong>는 30여년간의 경험을 바탕으로 <br />
                최고의 임베디드 시스템 개발을 지향합니다.
            </h1>
            <p>
                최적화된 하드웨어 설계, 운영체제, 미들웨어, 다양한 기능의 애플리케이션 개발에 주력하고 있습니다. <br />
                최근 우리는 임베디드 시스템의 경계를 넘어, 안드로이드 애플리케이션 및 솔루션 개발, 핀테크 기능 구현 등 서비스 분야로의 확장을
                이루어내고 있습니다. <br />
                이러한 변화는 기술의 발전과 고객의 다양한 요구에 부응하기 위한 우리의 지속적인 노력의 일환입니다.<br />
                <br />
                특히, 국내 신용카드 결제 산업에서 독보적인 기술력으로 국내외 인증을 획득하며, 신뢰할 수 있는 파트너로 자리매김하고 있습니다.<br />
                <br />
                우리는 혁신과 도전을 두려워하지 않는 유능한 인재를 찾고 있습니다. <br />
                빠르게 변화하는 디지털 환경에 발맞춰 마래를 함께 개척하고, 새로운 서비스 솔루션을 만들어 나갈 여러분의 열정을 기다립니다.
            </p>
            <img src="@/assets/tech_image01.png" alt="" />
        </SubSection>
    </LayoutSub>
</template>
<script>
import SubSection from '@/components/SubSection.vue';
import LayoutSub from '@/layouts/LayoutSub.vue';

export default {
    components: {
        LayoutSub,
        SubSection,
    },
};
</script>